module.exports = __webpack_public_path__ + "img/design.a18ad92.webp";